<template>
  <v-app>
    <v-main>
      <!-- toast -->
      <Toast ref="toast"/>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import Toast from './components/Toast.vue'

export default {
  name: 'App',
  components:{
    Toast
  },
  data: () => ({
    //
  }),
  mounted() {
    this.$root.toast = this.$refs.toast
    window.toast = this.$refs.toast
  },
};
</script>
